import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useMemo } from "react";
import { TConfigSelect } from "..";
import { usePermission } from "../../../../../components/PermissionGuard";

import AcUnitOutlinedIcon from "@mui/icons-material/AcUnitOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

export default function SideMenu({ select, handleSelect }: SideMenuProps) {

  const colorIcon = useMemo(() => "black", []);

  const options: Toptions = [
    {
      label: "Sazonalidade",
      icon: <AcUnitOutlinedIcon sx={{ color: colorIcon }} />,
      havePermission: usePermission("estoque.configuracoes-gerenciar-sazonalidades"),
      disabled: false,
    },
    {
      label: "Setores",
      icon: <CategoryOutlinedIcon sx={{ color: colorIcon }} />,
      havePermission: usePermission("estoque.configuracoes"),
      disabled: false,
    },
    {
      label: "Departamentos",
      icon: <AccountTreeOutlinedIcon sx={{ color: colorIcon }} />,
      havePermission: usePermission("estoque.configuracoes"),
      disabled: false,
    },
    {
      label: "Compradores",
      icon: <ShoppingCartOutlinedIcon sx={{ color: colorIcon }} />,
      havePermission: usePermission("estoque.configuracoes-gerenciar-compradores"),
      disabled: false,
    },
  ]

  return (
    <>
      <List>
        {options.map((item, index) => {
          const itemSelecionado = item.label === select;

          if (!item.havePermission) return <></>;

          return (
            <ListItem
              disablePadding
              key={index}
              onClick={() => (!item.disabled ? handleSelect(item.label) : "")}
              sx={{ backgroundColor: itemSelecionado ? "#F0F0F0" : "unset" }}
            >
              <ListItemButton disabled={item.disabled}>
                <ListItemIcon>{item.icon}</ListItemIcon>

                <ListItemText primary={item.label} />

                <KeyboardArrowRightIcon sx={{ color: "black" }} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </>
  );
}

interface SideMenuProps {
  select: TConfigSelect;
  handleSelect: (arg: TConfigSelect) => void;
}

type Toptions = Array<{
  label: TConfigSelect;
  icon: JSX.Element;
  havePermission: boolean;
  disabled: boolean;
}>;

export type TDataImagens = {
  logo_image: string | null;
  cover_image: string | null;
};
